export enum HubDefaultFieldType {
    FIRST_NAME = 'FIRST_NAME',
    LAST_NAME = 'LAST_NAME',
    EMAIL = 'EMAIL',
    ORGANIZATION_NAME = 'ORGANIZATION_NAME',
    ASSISTANT_EMAIL = 'ASSISTANT_EMAIL',
    TITLE = 'TITLE',
    SALUTATION = 'SALUTATION',
    PHONE = 'PHONE',
}

export enum HubCustomFieldType {
    Text = 'Text',
    Dropdown = 'Dropdown',
    Textarea = 'Textarea',
    Checkbox = 'Checkbox',
}

export interface IHubRegistrationFieldConfiguration {
    formName: string;
    mandatory: boolean;
    visible: boolean;
    order: number;
}

export interface IHubCustomField {
    customFieldId: number;
    fieldId: string;
    label: string;
    description?: string;
    type: HubCustomFieldType;
    configurations: IHubRegistrationFieldConfiguration[];
    locked?: boolean;
    optionsList?: string[];
}

export interface IHubRegistrationField {
    type: HubDefaultFieldType;
    defaultFieldId: number;
    defaultFieldTitle: string;
    label: string;
    triaged: boolean;
    configurations: IHubRegistrationFieldConfiguration[];
    canBeHidden?: boolean;
    canBeOptional?: boolean;
    locked?: boolean;
    default?: boolean;
}

export interface IHubRegistrationFormDTO {
    fields: IHubRegistrationField[];
    triagedRegistrationEnabled?: boolean;
}

export abstract class IHubRegistrationConfigurationDAO {
    public abstract getRegistrationFormConfiguration(
        accountId: number,
        eventHubId: number
    ): Promise<IHubRegistrationFormDTO>;

    public abstract updateRegistrationFormConfiguration(
        accountId: number,
        eventHubId: number,
        configuration: IHubRegistrationFormDTO
    ): Promise<IHubRegistrationFormDTO>;

    public abstract deleteCustomField(
        accountId: number,
        eventHubId: number,
        customFieldId: number
    ): Promise<void>;
}
